import { render, staticRenderFns } from "./PhotoGalleryCard.vue?vue&type=template&id=631b9a94&scoped=true&"
import script from "./PhotoGalleryCard.vue?vue&type=script&lang=js&"
export * from "./PhotoGalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGalleryCard.vue?vue&type=style&index=0&id=631b9a94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b9a94",
  null
  
)

export default component.exports